import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CalendarInput from '../../ui/calendar-input';

interface OneTimeProvisionProps {
    date: string;
    setDate: (val: string) => void;
    errorDate: boolean;
    helperText?: string;
    minDate?: string;
}

const OneTimeProvision: React.FC<OneTimeProvisionProps> = ({ date, setDate, errorDate, helperText, minDate }) => {
    return (
        <Box mb={2}>
            <Typography sx={{ fontWeight: 500, fontSize: 15, mb: 0.5, color: 'var(--color-text-muted)' }}>
                Transaction Date <span style={{ color: '#F44336' }}>*</span>
            </Typography>
            <CalendarInput
                value={date}
                onChange={setDate}
                error={errorDate}
                helperText={helperText}
                minDate={minDate}
            />
        </Box>
    );
};

export default OneTimeProvision;